import React, { useCallback, useRef } from 'react';
import { BulkUploadDialogPaper } from '../styles';
import { BulkUploadDialogCloseContext } from './bulkUploadDialogClose';

/**
 * The one frame bulk upload runs in, wherever it is entered from.
 *
 * Step 1 used to render as a fixed panel over the docs screen while steps 2-5
 * opened in this dialog on /drafts/:assignmentId — the same wizard wearing two
 * different frames, with a landing page wedged between them. Both entry points
 * mount this instead, so creating the draft at step 1 changes the route
 * underneath the popup and nothing else.
 *
 * `open` is the only gate: MUI renders nothing while it is false, so the flow
 * still unmounts — and its queries still stop — between visits, but the modal
 * itself is reused and gets its close transition.
 *
 * A backdrop click or Escape first asks the wizard inside (useBulkUploadDialogClose),
 * so they warn exactly where its Close button does.
 */
export const BulkUploadDialog = ({ open, onClose, children }) => {
  const interceptRef = useRef(null);
  const handleClose = useCallback(
    (event, reason) => {
      if (interceptRef.current?.() === true) return;
      onClose?.(event, reason);
    },
    [onClose]
  );
  return (
    <BulkUploadDialogCloseContext.Provider value={interceptRef}>
      <BulkUploadDialogPaper
        open={open}
        onClose={handleClose}
        maxWidth={false}
        fullWidth
        data-testid="bulk-upload-dialog"
      >
        {children}
      </BulkUploadDialogPaper>
    </BulkUploadDialogCloseContext.Provider>
  );
};
